export default __webpack_public_path__ + "static/media/bombillo.2f508ddb.png";